/**
 * MIT License
 * 
 * Copyright (c) 2017 Creative Tim
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */










import React, { useState,useContext } from 'react';

import Sidebarnew from './Sidebarnew'; // Adjust the path according to your file structure
import Dashboardnewclient from './Dashboardnewclient';
import ClientInvoices from './Clientdasboarddata/ClientInvoices';
import ClientProjectInfo from './Clientdasboarddata/ClientProjectInfo';
import SidebarContext from './SidebarContext'; // Adjust the import path accordingly


import { Box,styled } from '@mui/material';

const LayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : '#f0f0f0',
  margin: 0,
  height: '100vh',
  width: '100vw',
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  transition: 'background-color 0.3s ease',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
}));

const ContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed'
})(({ theme, collapsed }) => ({
  flexGrow: 1,
  overflowY: 'auto',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  transition: 'margin-left 0.3s, width 0.3s',
  marginLeft: collapsed ? '60px' : '240px',
  width: collapsed ? 'calc(100% - 60px)' : 'calc(100% - 240px)',
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : 'inherit',
  color: theme.palette.mode === 'dark' ? theme.palette.text.primary : 'inherit'
}));

const RowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '20px',
  height: 'calc(100vh - 7rem)',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    margin: 'auto',
    height: 'auto'
  }
}));

const ContainerWithSameHeight = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : 'white',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    margin: 'auto',
    height: 'auto'
  }
}));

const TalentdashboardContainer = styled(ContainerWithSameHeight)(({ theme }) => ({
  width: '70%',
  marginRight: '10px',
  borderRadius: '15px',
  boxShadow: theme.palette.mode === 'dark' 
    ? '0 4px 8px rgba(0, 0, 0, 0.5) !important'
    : '0 4px 8px rgba(0, 0, 0, 0.3) !important',
  '@media (max-width: 768px)': {
    width: '100%',
    marginBottom: '10px'
  }
}));

const InfoDummyContainer = styled(ContainerWithSameHeight)(({ theme }) => ({
  width: '30%',
  borderRadius: '15px',
  boxShadow: theme.palette.mode === 'dark'
    ? '0 4px 8px rgba(0, 0, 0, 0.5)'
    : '0 4px 8px rgba(0, 0, 0, 0.3)',
  '@media (max-width: 768px)': {
    width: '100%',
    marginBottom: '10px'
  }
}));

const StakeholderDashboard = () => {
  const { collapsed, setCollapsed } = useContext(SidebarContext);
 
  return (
    <LayoutContainer>
     <Sidebarnew  collapsed={collapsed} setCollapsed={setCollapsed} />
      <ContentContainer collapsed={collapsed}>
        <Dashboardnewclient />
        <RowContainer>
          <TalentdashboardContainer>
            <ClientInvoices />
          </TalentdashboardContainer>
          <InfoDummyContainer>
            <ClientProjectInfo />
          </InfoDummyContainer>
        </RowContainer>
      </ContentContainer>
    </LayoutContainer>
  );
};

export default StakeholderDashboard;
